import React, { useEffect, useState } from "react";
import server from "../../api/server.js";
import "../loader.css"
import CallDetails from "../dashboard/calls/CallDetails.jsx";
import { FaTimes } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import AddSampleModal from "./AddSampleModal.jsx"
import { useToast } from '../../context/ToastContext.jsx';
import { IoAdd } from "react-icons/io5";

const SampleTestModal = ({clientID, serviceID, emailID, moduleName, onClose}) => {
    const { showToast } = useToast();
    const [client_id, setClient_id] = useState(null)
    const [service_id, setService_id] = useState(null)
    const [email, setEmail] = useState(null)
    const [module_name, setModule_name] = useState(null)
    const [loading, setLoading] = useState(false)
    const [sampleItems, setSampleItems] = useState([])
    const [call_id, setCall_id] = useState(null)
    const [showCallDetails, setShowCallDetails] = useState(false)
    const [showConfirmBox, setShowConfirmBox] = useState(false)
    const [showAddModal, setShowAddModal] = useState(false)

    const gotoCall = (id) => {
        setCall_id(id)
        setShowCallDetails(true)
    }
    const handleCloseModal = () => {
        onClose()
    }

    const get_test_samples_data = async() => {
        try {
            setLoading(true)
            let res = await server.getTestSamplesList(client_id, service_id, email, 'apps', undefined, module_name)
            if (res.status === 200){
                let resp = await res.json()
                setSampleItems(resp.data)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    }
    const formatEpochToReadableDate = (epoch) => {
        const date = new Date(epoch*1000);
        const options = { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
        return date.toLocaleString('en-GB', options).replace(',', '');
    };
    const handleCloseAddModal = () => {
        setShowAddModal(false)
    }
    const handleSaveSample = async (id, module_name) => {
        try {
            setLoading(true);
            let res = await server.postTestSamples({client_id, service_id, email, id, module_name, 'menu': 'apps', 'submenu': undefined})
            if(res.status === 200){
                get_test_samples_data();
            }else{
                let resp = await res.json()
                showToast(resp.error, "error")
            }
            setShowAddModal(false);
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }
    }
    const handleSaveAddModalData = (config) => {
        if(config){
            if(config.call_id && config.module_name){
                handleSaveSample(config.call_id, config.module_name.toLowerCase().replace(' ', '_'))
            }
        }
    }
    const handleClose = () => {
        setCall_id(null)
        setShowCallDetails(false)
    }
    const handleAddSample = () => {
        setShowAddModal(true);
    }
    const deleteSample = async () => {
        try {
            setLoading(true);
            let res = await server.updateTestSamples({client_id, service_id, email, call_id, module_name, 'menu': 'apps', 'submenu': undefined})
            if(res.status === 200){
                get_test_samples_data();
                setCall_id(null)
                setShowConfirmBox(false)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false);
            setCall_id(null)
        }
    }
    const handleDeleteSample = (id) => {
        setCall_id(id)
        setShowConfirmBox(true);
    }

    useEffect(()=> {
        if(clientID){
            setClient_id(clientID)
        }
        if(serviceID){
            setService_id(serviceID)
        }
        if(emailID){
            setEmail(emailID)
        }
        if(moduleName){
            setModule_name(moduleName)
        }
    }, [clientID, serviceID, emailID, moduleName])

    useEffect(()=> {
        if(client_id && service_id && email && module_name){
            get_test_samples_data()
        }
    }, [client_id, service_id, email])
    return (
        <div className="py-1 px-3">
            {
                module_name && !showCallDetails && (
                    <div className="flex items-center justify-between mb-6">
                            <div>
                            <h1 className="text-xl font-semibold text-gray-900 mb-2 flex items-center capitalize">{module_name === 'concerns_and_queries' ? 'Concerns & Queries' : module_name.replaceAll('_', ' ')}</h1>
                            <p className="text-gray-500 text-sm mt-1">Configure detailed {module_name === 'concerns_and_queries' ? 'Concerns & Queries' : module_name.replaceAll('_', ' ')} generation</p>
                            </div>
                            <div className="flex space-x-3">
                                <button 
                                className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 focus:outline-none"style={{height: "40px", borderRadius: "4px"}}
                                onClick={handleCloseModal}
                                >
                                Go Back
                                </button>
                                <button 
                                className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex items-center"
                                onClick={handleAddSample}
                                >
                                <IoAdd/> Add Sample
                                </button>
                            </div>
                        </div>
                )
            }
            {
                loading && (
                    <div className="flex justify-center items-center" style={{ height: "70vh", flexDirection: "column" }}>
                        <div className="loader"></div>
                        <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                    </div>
                )
            }
            {
                !loading && !showCallDetails && (
                    <div>
                        {
                            sampleItems.length === 0 && (
                                <div className="flex justify-center items-center" style={{ height: "70vh", flexDirection: "column" }}>
                                    <img src="/assets/paper.png" style={{height: "10vh"}} alt=""/>
                                    <h2 style={{textAlign: "center", fontSize: "24px"}}>No Call Details Found.</h2>
                                </div>
                            )
                        }
                        {
                            sampleItems.length > 0 && (
                                <div style={{height: "75vh", overflow: "auto"}}>
                                    <div className="overflow-hidden border border-gray-200 rounded-lg">
                                    <table className="min-w-full divide-y divide-gray-200">
                                        <thead className="bg-gray-50">
                                            <tr>
                                            <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{fontSize: "13px", fontWeight: "400"}}>Conversation ID</th>
                                            <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{fontSize: "13px", fontWeight: "400"}}>Added By</th>
                                            <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{fontSize: "13px", fontWeight: "400"}}>Added At</th>
                                            <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{fontSize: "13px", fontWeight: "400"}}>Action</th>
                                            <th scope="col" className="px-3 uppercase py-3 text-left text-xs font-medium text-gray-500 tracking-wider" style={{fontSize: "13px", fontWeight: "400"}}> </th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-200">
                                            {sampleItems.map((convo) => (
                                            <tr key={convo.id} className="border-b hover:bg-gray-50">
                                                <td className="px-4 py-3 text-blue-600 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.id}</td>
                                                <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{convo.created_by}</td>
                                                <td className="px-4 py-3 text-sm" style={{fontSize: "0.7rem", lineHeight: "1rem"}}>{formatEpochToReadableDate(convo.createdat)}</td>
                                                <td className="px-4 py-3 text-sm text-blue-600 text-sm pointer" style={{fontSize: "0.7rem", lineHeight: "1rem", cursor: "pointer"}} onClick={()=> gotoCall(convo.id)}>View Details</td>
                                                <td onClick={() => handleDeleteSample(convo.id)} className="px-4 py-3 text-sm pointer text-red-500" style={{fontSize: "1rem", lineHeight: "1rem", cursor: "pointer"}}><MdDelete/></td>
                                            </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
            {
                showCallDetails && (
                    <div style={{overflow: "auto", height: "86vh"}}>
                        <CallDetails selectedOption={service_id} open_type={handleClose} callIdProp={call_id} selectedClientId={client_id}/>
                    </div>
                )
            }
            {
            showConfirmBox && (
              <div style={{zIndex: "9999999999", position: "fixed", top: "0", left: "0", height: "100%", width: "100%", background: "rgba(0,0,0, 0.5)"}}>
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center p-4">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-md relative">
                <div className="flex justify-between items-center p-4 pb-2">
                  <h2 className="text-xl text-gray-700" style={{fontWeight: "550"}}>Are you sure?</h2>
                  <button 
                    onClick={() => {
                      {setShowConfirmBox(false); setCall_id(null);}
                    }}
                    className="text-gray-500 hover:text-gray-700"
                  >
                  <FaTimes style={{color: "slategray"}}/>
                  </button>
                </div>
                
                <div className="p-6 pt-2">
                  <p className="text-gray-500 text-sm">This sample will be deleted from the test set.</p>
                </div>
                
                <div className="flex justify-end gap-3 p-6 pt-6">
                  <button
                    onClick={() => {setShowConfirmBox(false); setCall_id(null);}}
                    className="px-6 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}
                  >
                    No
                  </button>
                  <button onClick={deleteSample}
                    className="px-6 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700" style={{height: "40px", borderRadius: "4px"}}
                  >
                    Yes
                  </button>
                </div>
              </div>
            </div>
        </div>
            )
          }

            {
                showAddModal && (
                    <div style={{position: "fixed", left: "0%", top: "0%", width: "100%", height: "100%", background: "rgba(0, 0, 0, 0.5)", zIndex: "1001"}}>
                        <div style={{position: "fixed", left: "33%", top: "30%", width: "32%", height: "35%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                        zIndex: "999999999", padding: "15px"}}>
                            <div style={{position: "absolute", right: "10px", top: "10px", cursor: "pointer"}} onClick={() => {setShowAddModal(false);}}><FaTimes style={{color: "slategray"}}/></div>
                            <AddSampleModal showType='Module' moduleName={module_name.toUpperCase().replace('_', ' ')} onCancel={handleCloseAddModal} onSave={handleSaveAddModalData}/>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default SampleTestModal;